import { render } from "./AttributeDropdownGeneric.vue?vue&type=template&id=c67a87ce&scoped=true"
import script from "./AttributeDropdownGeneric.vue?vue&type=script&lang=js"
export * from "./AttributeDropdownGeneric.vue?vue&type=script&lang=js"

import "./AttributeDropdownGeneric.vue?vue&type=style&index=0&id=c67a87ce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c67a87ce"]])

export default __exports__